/* global localStorage */
import decode from 'jwt-decode'
import router from '@/router'
import { setUserContext } from '@/lib/sentry'

const ACCESS_TOKEN_KEY = 'accessToken'
const REFRESH_TOKEN_KEY = 'refreshToken'

export function requireAuth (to, from, next) {
  if (!isLoggedIn()) {
    next({
      name: 'Login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

export function isLoggedIn () {
  const accessToken = getAccessToken()
  return !!accessToken && !isTokenExpired(accessToken)
}

function getTokenExpirationDate (encodedToken) {
  const token = decode(encodedToken)
  if (!token.exp) { return null }

  const date = new Date(0)
  date.setUTCSeconds(token.exp)

  return date
}

export function getUser () {
  if (isLoggedIn()) {
    const token = decode(getAccessToken())
    return token.user
  }
}

export function isTokenExpired (token) {
  const expirationDate = getTokenExpirationDate(token)
  return expirationDate < new Date()
}

export function getAccessToken () {
  return localStorage.getItem(ACCESS_TOKEN_KEY)
}

export function getRefreshToken () {
  return localStorage.getItem(REFRESH_TOKEN_KEY)
}

export function decodeToken (token) {
  return decode(token)
}

function clearAccessToken () {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
}

function clearRefreshToken () {
  localStorage.removeItem(REFRESH_TOKEN_KEY)
}

export function saveSession (userData) {
  localStorage.setItem(ACCESS_TOKEN_KEY, userData.token)
  setUserContext()
  // localStorage.setItem(ACCESS_TOKEN_KEY, userData.accessToken)
  // localStorage.setItem(REFRESH_TOKEN_KEY, userData.refreshToken)
}

export function clearSession () {
  clearAccessToken()
  clearRefreshToken()
  router.replace({'name': 'Login'})
}
